import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { DayPicker, DayButton } from "react-day-picker";
import { format } from "date-fns";
import { useDateFnsLocale } from "./useDateFnsLocale.js";
import { DateRangeBackgroundFill } from "./DatePicker.styles.js";
function DateRangePickerView({
  valueRange,
  setRange,
  disabledDays,
  labels,
  components
}) {
  const locale = useDateFnsLocale();
  function handleDaySelect(dateRange) {
    setRange(dateRange);
  }
  return /* @__PURE__ */ jsx(DayPicker, {
    locale,
    numberOfMonths: 1,
    labels,
    components: {
      ...components,
      DayButton: (props) => /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(DayButton, {
          ...props
        }), /* @__PURE__ */ jsx(DateRangeBackgroundFill, {})]
      })
    },
    defaultMonth: (valueRange == null ? void 0 : valueRange.from) ? new Date(valueRange.from) : void 0,
    showOutsideDays: true,
    mode: "range",
    disabled: disabledDays,
    autoFocus: true,
    formatters: {
      formatWeekdayName: (weekday, options) => format(weekday, "cccccc", options)
    },
    selected: valueRange,
    onSelect: handleDaySelect
  });
}
export {
  DateRangePickerView
};
//# sourceMappingURL=DateRangePickerView.js.map
